export default __webpack_public_path__ + "static/media/appItunes.80d9f5d6.svg";